export default "__VITE_ASSET__cf8e9c57__"